import _ from 'lodash';
import React, {Component} from 'react';
import {Table} from 'semantic-ui-react';
import ChartsData from "../../data/ChartsData";
import LoadingRow from "../extras/LoadingRow";
import localDB from "../../data/localDB";
import UpgradeAccount from "../extras/UpgradeAccount";
import * as moment from "moment";

class TableProduct extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            column: null,
            direction: null,
            loading: true,
            time: null,
            date: moment.now()
        }
    }

    async loadData(branch_office, time, date) {
        this.setState({loading: true, time, date});
        ChartsData.getProductSales(branch_office, time, date).then(data =>{
            this.setState({data});
        }).finally(()=>{
            this.setState({loading: false});
        });
    };

    handleSort = clickedColumn => () => {
        const { column, data, direction } = this.state;
        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                direction: 'ascending',
            });

            return
        }
        this.setState({
            data: data.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    };

    selectedDate = () =>{
        if(this.state.time === 'd'){
            return moment(this.state.date).format("dddd, MMMM D [de] YYYY");
        }else if(this.state.time === 'w'){
            return moment(this.state.date).format("[Semana] ww, MMMM [de] YYYY");
        }else if(this.state.time === 'm'){
            return moment(this.state.date).format("MMMM [de] YYYY");
        }else if(this.state.time === 'y'){
            return moment(this.state.date).format("YYYY");
        }else{
            return '';
        }
    };

    render() {
        return (
                !localDB.checkPlanAccessExclude('reports_view_all') ? <Table sortable celled fixed striped selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='2'>{`${this.props.title} - ${this.selectedDate()}`}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell sorted={this.state.column === 'name' ? this.state.direction : null}
                                              onClick={this.handleSort('name')}>
                                Producto
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'total' ? this.state.direction : null}
                                              onClick={this.handleSort('total')}>
                                Unidades Vendidas
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {!this.state.loading ? _.map(this.state.data, ({id, name, total}, index) => (
                            <Table.Row key={index}>
                                <Table.Cell>{name}</Table.Cell>
                                <Table.Cell>{total}</Table.Cell>
                            </Table.Row>
                        )):<LoadingRow colSpan={2}/>}
                    </Table.Body>
                </Table>: <UpgradeAccount message='este informe'/>
        );
    }
}

export default TableProduct;



// WEBPACK FOOTER //
// ./src/components/charts/TableProduct.js